<template>
	<div class="card">
		<div class="card-header">
			<span class="fs-6">Data Pendukung</span>
		</div>
		<div class="card-body" v-loading="loading">
			<el-tabs v-model="activeTab" tab-position="top" type="border-card" @tab-click="handleTabClick" :before-leave="beforeLeaveTab">
				<el-tab-pane v-for="[key, val] of Object.entries(tables)" :key="key" :label="val.label" :name="val.name" />
				<router-view :data-pendukung="dataPendukung" :loading-data="loadingData" :update-editing="updateEditing" :modal-width="modalWidth" v-slot="{ Component }">
					<transition name="fade" mode="out-in">
						<div v-if="routeName === 'data-pendukung'" class="row g-3">
							<div v-for="d in jumlahData" :key="d" class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
								<div class="card">
									<div class="card-header small">
										{{ tables[d.table_name]?.label || d.table_name }}
										<router-link :to="{ name: tables[d.table_name]?.name }">
											<el-icon><i class="bi bi-box-arrow-in-up-right"></i></el-icon>
										</router-link>
									</div>
									<div class="card-body">
										<div class="d-flex gap-1 align-items-baseline">
											<transition name="slide-up" mode="out-in">
												<span class="fs-5" :key="d.row_count">
													{{ d.row_count }}
												</span>
											</transition>
											data
										</div>
									</div>
								</div>
							</div>
						</div>
						<component :is="Component" v-else />
					</transition>
				</router-view>
			</el-tabs>
		</div>
	</div>
</template>

<script>
export default {
	name: "PendukungView",
	data() {
		return {
			jumlahData: [],
			dataPendukung: {
				berkebutuhan_khusus: null,
				cita_cita: null,
				hobi: null,
				moda_transportasi: null,
				pekerjaan: null,
				pendidikan: null,
				pendidikan_dasar: null,
				penghasilan: null,
				status_ortu: null,
				tempat_tinggal: null,
			},
			loadingData: {
				berkebutuhan_khusus: false,
				cita_cita: false,
				hobi: false,
				moda_transportasi: false,
				pekerjaan: false,
				pendidikan: false,
				pendidikan_dasar: false,
				penghasilan: false,
				status_ortu: false,
				tempat_tinggal: false,
			},
			loading: true,
			activeTab: "",
			isEditing: false,
			tables: {
				berkebutuhan_khusus: {
					label: "Berkebutuhan Khusus",
					name: "berkebutuhan-khusus",
				},
				cita_cita: {
					label: "Cita-cita",
					name: "cita-cita",
				},
				hobi: {
					label: "Hobi",
					name: "hobi",
				},
				moda_transportasi: {
					label: "Moda Transportasi",
					name: "moda-transportasi",
				},
				pekerjaan: {
					label: "Pekerjaan",
					name: "pekerjaan",
				},
				pendidikan: {
					label: "Pendidikan",
					name: "pendidikan",
				},
				pendidikan_dasar: {
					label: "Pendidikan Dasar",
					name: "pendidikan-dasar",
				},
				penghasilan: {
					label: "Penghasilan",
					name: "penghasilan",
				},
				status_ortu: {
					label: "Status Orang Tua",
					name: "status-ortu",
				},
				tempat_tinggal: {
					label: "Tempat Tinggal",
					name: "tempat-tinggal",
				},
			},
			modalWidth: "50%",
			insertedBerkebutuhanKhusus: async () => {
				const table = this.jumlahData.find((j) => j.table_name === "berkebutuhan_khusus");
				if (table) table.row_count += 1;

				if (!this.dataPendukung.berkebutuhan_khusus) return;

				this.loadingData.berkebutuhan_khusus = true;

				await this.getDataPendukung("berkebutuhan_khusus", "berkebutuhan-khusus");
				setTimeout(() => {
					this.loadingData.berkebutuhan_khusus = false;
				}, 500);
			},
			updatedBerkebutuhanKhusus: (data) => {
				if (!this.dataPendukung.berkebutuhan_khusus) return;
				const d = JSON.parse(data);

				const ts = new Date();
				const oldData = this.dataPendukung.berkebutuhan_khusus.find((f) => f.berkebutuhan_khusus_id === d.berkebutuhan_khusus_id);

				if (!oldData) return;

				oldData.jenis = d.jenis;
				oldData.last_update = ts.toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" });
			},
			deletedBerkebutuhanKhusus: (data) => {
				const table = this.jumlahData.find((j) => j.table_name === "berkebutuhan_khusus");
				if (table) table.row_count -= 1;

				if (!this.dataPendukung.berkebutuhan_khusus) return;
				const d = JSON.parse(data);

				const oldIndex = this.dataPendukung.berkebutuhan_khusus.findIndex((f) => f.berkebutuhan_khusus_id === d.berkebutuhan_khusus_id);

				if (oldIndex === -1) return;

				this.dataPendukung.berkebutuhan_khusus.splice(oldIndex, 1);
			},
			insertedCitaCita: async () => {
				const table = this.jumlahData.find((j) => j.table_name === "cita_cita");
				if (table) table.row_count += 1;

				if (!this.dataPendukung.cita_cita) return;

				this.loadingData.cita_cita = true;

				await this.getDataPendukung("cita_cita", "cita-cita");
				setTimeout(() => {
					this.loadingData.cita_cita = false;
				}, 500);
			},
			updatedCitaCita: (data) => {
				if (!this.dataPendukung.cita_cita) return;
				const d = JSON.parse(data);

				const ts = new Date();
				const oldData = this.dataPendukung.cita_cita.find((f) => f.cita_cita_id === d.cita_cita_id);

				if (!oldData) return;

				oldData.nama = d.nama;
				oldData.last_update = ts.toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" });
			},
			deletedCitaCita: (data) => {
				const table = this.jumlahData.find((j) => j.table_name === "cita_cita");
				if (table) table.row_count -= 1;

				if (!this.dataPendukung.cita_cita) return;
				const d = JSON.parse(data);

				const oldIndex = this.dataPendukung.cita_cita.findIndex((f) => f.cita_cita_id === d.cita_cita_id);

				if (oldIndex === -1) return;

				this.dataPendukung.cita_cita.splice(oldIndex, 1);
			},
			insertedHobi: async () => {
				const table = this.jumlahData.find((j) => j.table_name === "hobi");
				if (table) table.row_count += 1;

				if (!this.dataPendukung.hobi) return;

				this.loadingData.hobi = true;

				await this.getDataPendukung("hobi", "hobi");
				setTimeout(() => {
					this.loadingData.hobi = false;
				}, 500);
			},
			updatedHobi: (data) => {
				if (!this.dataPendukung.hobi) return;
				const d = JSON.parse(data);

				const ts = new Date();
				const oldData = this.dataPendukung.hobi.find((f) => f.hobi_id === d.hobi_id);

				if (!oldData) return;

				oldData.nama = d.nama;
				oldData.last_update = ts.toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" });
			},
			deletedHobi: (data) => {
				const table = this.jumlahData.find((j) => j.table_name === "hobi");
				if (table) table.row_count -= 1;

				if (!this.dataPendukung.hobi) return;
				const d = JSON.parse(data);

				const oldIndex = this.dataPendukung.hobi.findIndex((f) => f.hobi_id === d.hobi_id);

				if (oldIndex === -1) return;

				this.dataPendukung.hobi.splice(oldIndex, 1);
			},
			insertedModaTransportasi: async () => {
				const table = this.jumlahData.find((j) => j.table_name === "moda_transportasi");
				if (table) table.row_count += 1;

				if (!this.dataPendukung.moda_transportasi) return;

				this.loadingData.moda_transportasi = true;

				await this.getDataPendukung("moda_transportasi", "moda-transportasi");
				setTimeout(() => {
					this.loadingData.moda_transportasi = false;
				}, 500);
			},
			updatedModaTransportasi: (data) => {
				if (!this.dataPendukung.moda_transportasi) return;
				const d = JSON.parse(data);

				const ts = new Date();
				const oldData = this.dataPendukung.moda_transportasi.find((f) => f.moda_transportasi_id === d.moda_transportasi_id);

				if (!oldData) return;

				oldData.jenis = d.jenis;
				oldData.last_update = ts.toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" });
			},
			deletedModaTransportasi: (data) => {
				const table = this.jumlahData.find((j) => j.table_name === "moda_transportasi");
				if (table) table.row_count -= 1;

				if (!this.dataPendukung.moda_transportasi) return;
				const d = JSON.parse(data);

				const oldIndex = this.dataPendukung.moda_transportasi.findIndex((f) => f.moda_transportasi_id === d.moda_transportasi_id);

				if (oldIndex === -1) return;

				this.dataPendukung.moda_transportasi.splice(oldIndex, 1);
			},
			insertedPekerjaan: async () => {
				const table = this.jumlahData.find((j) => j.table_name === "pekerjaan");
				if (table) table.row_count += 1;

				if (!this.dataPendukung.pekerjaan) return;

				this.loadingData.pekerjaan = true;

				await this.getDataPendukung("pekerjaan", "pekerjaan");
				setTimeout(() => {
					this.loadingData.pekerjaan = false;
				}, 500);
			},
			updatedPekerjaan: (data) => {
				if (!this.dataPendukung.pekerjaan) return;
				const d = JSON.parse(data);

				const ts = new Date();
				const oldData = this.dataPendukung.pekerjaan.find((f) => f.pekerjaan_id === d.pekerjaan_id);

				if (!oldData) return;

				oldData.nama = d.nama;
				oldData.last_update = ts.toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" });
			},
			deletedPekerjaan: (data) => {
				const table = this.jumlahData.find((j) => j.table_name === "pekerjaan");
				if (table) table.row_count -= 1;

				if (!this.dataPendukung.pekerjaan) return;
				const d = JSON.parse(data);

				const oldIndex = this.dataPendukung.pekerjaan.findIndex((f) => f.pekerjaan_id === d.pekerjaan_id);

				if (oldIndex === -1) return;

				this.dataPendukung.pekerjaan.splice(oldIndex, 1);
			},
			insertedPendidikan: async () => {
				const table = this.jumlahData.find((j) => j.table_name === "pendidikan");
				if (table) table.row_count += 1;

				if (!this.dataPendukung.pendidikan) return;

				this.loadingData.pendidikan = true;

				await this.getDataPendukung("pendidikan", "pendidikan");
				setTimeout(() => {
					this.loadingData.pendidikan = false;
				}, 500);
			},
			updatedPendidikan: (data) => {
				if (!this.dataPendukung.pendidikan) return;
				const d = JSON.parse(data);

				const ts = new Date();
				const oldData = this.dataPendukung.pendidikan.find((f) => f.pendidikan_id === d.pendidikan_id);

				if (!oldData) return;

				oldData.jenjang = d.jenjang;
				oldData.last_update = ts.toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" });
			},
			deletedPendidikan: (data) => {
				const table = this.jumlahData.find((j) => j.table_name === "pendidikan");
				if (table) table.row_count -= 1;

				if (!this.dataPendukung.pendidikan) return;
				const d = JSON.parse(data);

				const oldIndex = this.dataPendukung.pendidikan.findIndex((f) => f.pendidikan_id === d.pendidikan_id);

				if (oldIndex === -1) return;

				this.dataPendukung.pendidikan.splice(oldIndex, 1);
			},
			insertedPendidikanDasar: async () => {
				const table = this.jumlahData.find((j) => j.table_name === "pendidikan_dasar");
				if (table) table.row_count += 1;

				if (!this.dataPendukung.pendidikan_dasar) return;

				this.loadingData.pendidikan_dasar = true;

				await this.getDataPendukung("pendidikan_dasar", "pendidikan-dasar");
				setTimeout(() => {
					this.loadingData.pendidikan_dasar = false;
				}, 500);
			},
			updatedPendidikanDasar: (data) => {
				if (!this.dataPendukung.pendidikan_dasar) return;
				const d = JSON.parse(data);

				const ts = new Date();
				const oldData = this.dataPendukung.pendidikan_dasar.find((f) => f.pendidikan_dasar_id === d.pendidikan_dasar_id);

				if (!oldData) return;

				if (d.singkatan) oldData.singkatan = d.singkatan;
				if (d.deskripsi) oldData.deskripsi = d.deskripsi;
				oldData.last_update = ts.toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" });
			},
			deletedPendidikanDasar: (data) => {
				const table = this.jumlahData.find((j) => j.table_name === "pendidikan_dasar");
				if (table) table.row_count -= 1;

				if (!this.dataPendukung.pendidikan_dasar) return;
				const d = JSON.parse(data);

				const oldIndex = this.dataPendukung.pendidikan_dasar.findIndex((f) => f.pendidikan_dasar_id === d.pendidikan_dasar_id);

				if (oldIndex === -1) return;

				this.dataPendukung.pendidikan_dasar.splice(oldIndex, 1);
			},
			insertedPenghasilan: async () => {
				const table = this.jumlahData.find((j) => j.table_name === "penghasilan");
				if (table) table.row_count += 1;

				if (!this.dataPendukung.penghasilan) return;

				this.loadingData.penghasilan = true;

				await this.getDataPendukung("penghasilan", "penghasilan");
				setTimeout(() => {
					this.loadingData.penghasilan = false;
				}, 500);
			},
			updatedPenghasilan: (data) => {
				if (!this.dataPendukung.penghasilan) return;
				const d = JSON.parse(data);

				const ts = new Date();
				const oldData = this.dataPendukung.penghasilan.find((f) => f.penghasilan_id === d.penghasilan_id);

				if (!oldData) return;

				oldData.rentang = d.rentang;
				oldData.last_update = ts.toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" });
			},
			deletedPenghasilan: (data) => {
				const table = this.jumlahData.find((j) => j.table_name === "penghasilan");
				if (table) table.row_count -= 1;

				if (!this.dataPendukung.penghasilan) return;
				const d = JSON.parse(data);

				const oldIndex = this.dataPendukung.penghasilan.findIndex((f) => f.penghasilan_id === d.penghasilan_id);

				if (oldIndex === -1) return;

				this.dataPendukung.penghasilan.splice(oldIndex, 1);
			},
			insertedStatusOrtu: async () => {
				const table = this.jumlahData.find((j) => j.table_name === "status_ortu");
				if (table) table.row_count += 1;

				if (!this.dataPendukung.status_ortu) return;

				this.loadingData.status_ortu = true;

				await this.getDataPendukung("status_ortu", "status-ortu");
				setTimeout(() => {
					this.loadingData.status_ortu = false;
				}, 500);
			},
			updatedStatusOrtu: (data) => {
				if (!this.dataPendukung.status_ortu) return;
				const d = JSON.parse(data);
				const { deskripsi = null, adds = [], dels = [] } = d;

				const ts = new Date();
				const oldData = this.dataPendukung.status_ortu.find((f) => f.status_ortu_id === d.status_ortu_id);

				if (!oldData) return;

				oldData.required_fields_count = oldData.required_fields_count - dels.length + adds.length;

				adds.forEach((c) => {
					const field = oldData.fields?.find((f) => f.col === c);
					if (field) {
						field.is_required = true;
					}
				});
				dels.forEach((c) => {
					const field = oldData.fields?.find((f) => f.col === c);
					if (field) {
						field.is_required = false;
					}
				});

				if (deskripsi) oldData.deskripsi = d.deskripsi;
				oldData.last_update = ts.toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" });
			},
			deletedStatusOrtu: (data) => {
				const table = this.jumlahData.find((j) => j.table_name === "status_ortu");
				if (table) table.row_count -= 1;

				if (!this.dataPendukung.status_ortu) return;
				const d = JSON.parse(data);

				const oldIndex = this.dataPendukung.status_ortu.findIndex((f) => f.status_ortu_id === d.status_ortu_id);

				if (oldIndex === -1) return;

				this.dataPendukung.status_ortu.splice(oldIndex, 1);
			},
			insertedTempatTinggal: async () => {
				const table = this.jumlahData.find((j) => j.table_name === "tempat_tinggal");
				if (table) table.row_count += 1;

				if (!this.dataPendukung.tempat_tinggal) return;

				this.loadingData.tempat_tinggal = true;

				await this.getDataPendukung("tempat_tinggal", "tempat-tinggal");
				setTimeout(() => {
					this.loadingData.tempat_tinggal = false;
				}, 500);
			},
			updatedTempatTinggal: (data) => {
				if (!this.dataPendukung.tempat_tinggal) return;
				const d = JSON.parse(data);

				const ts = new Date();
				const oldData = this.dataPendukung.tempat_tinggal.find((f) => f.tempat_tinggal_id === d.tempat_tinggal_id);

				if (!oldData) return;

				oldData.jenis = d.jenis;
				oldData.last_update = ts.toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" });
			},
			deletedTempatTinggal: (data) => {
				const table = this.jumlahData.find((j) => j.table_name === "tempat_tinggal");
				if (table) table.row_count -= 1;

				if (!this.dataPendukung.tempat_tinggal) return;
				const d = JSON.parse(data);

				const oldIndex = this.dataPendukung.tempat_tinggal.findIndex((f) => f.tempat_tinggal_id === d.tempat_tinggal_id);

				if (oldIndex === -1) return;

				this.dataPendukung.tempat_tinggal.splice(oldIndex, 1);
			},
		};
	},
	computed: {
		routeName() {
			return this.$route.name;
		},
	},
	watch: {
		routeName: {
			immediate: true,
			async handler(val) {
				this.activeTab = val;
				if (val === "data-pendukung") return;

				const entries = Object.entries(this.tables);
				const table = entries.find(([key, value]) => !!key && value.name === val);

				if (!table) return;
				if (this.dataPendukung[table[0]]) return;

				this.loadingData[table[0]] = true;

				await this.getDataPendukung(table[0], table[1]?.name);
				setTimeout(() => {
					this.loadingData[table[0]] = false;
				}, 500);
			},
		},
	},
	mounted() {
		this.handleResize();
		window.addEventListener("resize", this.handleResize);
		window.addEventListener("beforeunload", this.handleBeforeUnload);
		this.getDataCount();
		this.$ws.main.on("berkebutuhan-khusus:inserted", this.insertedBerkebutuhanKhusus);
		this.$ws.main.on("berkebutuhan-khusus:updated", this.updatedBerkebutuhanKhusus);
		this.$ws.main.on("berkebutuhan-khusus:deleted", this.deletedBerkebutuhanKhusus);
		this.$ws.main.on("cita-cita:inserted", this.insertedCitaCita);
		this.$ws.main.on("cita-cita:updated", this.updatedCitaCita);
		this.$ws.main.on("cita-cita:deleted", this.deletedCitaCita);
		this.$ws.main.on("hobi:inserted", this.insertedHobi);
		this.$ws.main.on("hobi:updated", this.updatedHobi);
		this.$ws.main.on("hobi:deleted", this.deletedHobi);
		this.$ws.main.on("moda-transportasi:inserted", this.insertedModaTransportasi);
		this.$ws.main.on("moda-transportasi:updated", this.updatedModaTransportasi);
		this.$ws.main.on("moda-transportasi:deleted", this.deletedModaTransportasi);
		this.$ws.main.on("pekerjaan:inserted", this.insertedPekerjaan);
		this.$ws.main.on("pekerjaan:updated", this.updatedPekerjaan);
		this.$ws.main.on("pekerjaan:deleted", this.deletedPekerjaan);
		this.$ws.main.on("pendidikan:inserted", this.insertedPendidikan);
		this.$ws.main.on("pendidikan:updated", this.updatedPendidikan);
		this.$ws.main.on("pendidikan:deleted", this.deletedPendidikan);
		this.$ws.main.on("pendidikan-dasar:inserted", this.insertedPendidikanDasar);
		this.$ws.main.on("pendidikan-dasar:updated", this.updatedPendidikanDasar);
		this.$ws.main.on("pendidikan-dasar:deleted", this.deletedPendidikanDasar);
		this.$ws.main.on("penghasilan:inserted", this.insertedPenghasilan);
		this.$ws.main.on("penghasilan:updated", this.updatedPenghasilan);
		this.$ws.main.on("penghasilan:deleted", this.deletedPenghasilan);
		this.$ws.main.on("status-ortu:inserted", this.insertedStatusOrtu);
		this.$ws.main.on("status-ortu:updated", this.updatedStatusOrtu);
		this.$ws.main.on("status-ortu:deleted", this.deletedStatusOrtu);
		this.$ws.main.on("tempat-tinggal:inserted", this.insertedTempatTinggal);
		this.$ws.main.on("tempat-tinggal:updated", this.updatedTempatTinggal);
		this.$ws.main.on("tempat-tinggal:deleted", this.deletedTempatTinggal);
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.handleResize);
		window.removeEventListener("beforeunload", this.handleBeforeUnload);
		this.$ws.main.off("berkebutuhan-khusus:inserted");
		this.$ws.main.off("berkebutuhan-khusus:updated");
		this.$ws.main.off("berkebutuhan-khusus:deleted");
		this.$ws.main.off("cita-cita:inserted");
		this.$ws.main.off("cita-cita:updated");
		this.$ws.main.off("cita-cita:deleted");
		this.$ws.main.off("hobi:inserted");
		this.$ws.main.off("hobi:updated");
		this.$ws.main.off("hobi:deleted");
		this.$ws.main.off("moda-transportasi:inserted");
		this.$ws.main.off("moda-transportasi:updated");
		this.$ws.main.off("moda-transportasi:deleted");
		this.$ws.main.off("pekerjaan:inserted");
		this.$ws.main.off("pekerjaan:updated");
		this.$ws.main.off("pekerjaan:deleted");
		this.$ws.main.off("pendidikan:inserted");
		this.$ws.main.off("pendidikan:updated");
		this.$ws.main.off("pendidikan:deleted");
		this.$ws.main.off("pendidikan-dasar:inserted");
		this.$ws.main.off("pendidikan-dasar:updated");
		this.$ws.main.off("pendidikan-dasar:deleted");
		this.$ws.main.off("penghasilan:inserted");
		this.$ws.main.off("penghasilan:updated");
		this.$ws.main.off("penghasilan:deleted");
		this.$ws.main.off("status-ortu:inserted");
		this.$ws.main.off("status-ortu:updated");
		this.$ws.main.off("status-ortu:deleted");
		this.$ws.main.off("tempat-tinggal:inserted");
		this.$ws.main.off("tempat-tinggal:updated");
		this.$ws.main.off("tempat-tinggal:deleted");
	},
	methods: {
		updateEditing(val) {
			this.isEditing = val;
		},
		beforeLeaveTab() {
			return new Promise((resolve, reject) => {
				if (this.isEditing) {
					reject();
				}
				resolve();
			});
		},
		handleTabClick(val) {
			this.$router.push({ name: val?.paneName || val });
		},
		handleBeforeUnload(e) {
			if (this.isEditing) {
				e.preventDefault();
				e.returnValue = "";
				return "";
			}
		},
		async getDataCount() {
			try {
				const { data } = await this.$defaultApi.post("/data/count", {});

				this.jumlahData = data.jumlah_data;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			} finally {
				setTimeout(() => {
					this.loading = false;
				}, 500);
			}
		},
		async getDataPendukung(table_name, path) {
			try {
				const { data } = await this.$defaultApi.post(`/data/${path}`, {});

				const result = data[table_name];

				result.forEach((r) => {
					const temp = r.updated_at ? new Date(r.updated_at) : new Date(r.created_at);
					r.last_update = temp.toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" });
				});

				this.dataPendukung[table_name] = data[table_name];
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			}
		},
		handleResize() {
			const w = window.innerWidth;
			if (w < 500) this.modalWidth = "90%";
			else if (w < 768) this.modalWidth = "80%";
			else if (w < 992) this.modalWidth = "60%";
			else if (w < 1200) this.modalWidth = "45%";
			else if (w < 1500) this.modalWidth = "35%";
			else if (w < 1920) this.modalWidth = "30%";
			else this.modalWidth = "25%";
		},
	},
};
</script>

<style scoped></style>
